@if (value().url) {
  <a
    [href]="value().url"
    target="_blank"
    rel="noopener noreferrer"
    class="external-link"
  >
    {{ value().text }}
  </a>
}
